require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-create-a-class-to-target-with-jquery-selectors.json") })
        }
      }, "path---front-end-libraries-bootstrap-create-a-class-to-target-with-jquery-selectors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-create-a-class-to-target-with-jquery-selectors!./.cache/json/front-end-libraries-bootstrap-create-a-class-to-target-with-jquery-selectors.json
// module id = 1997
// module chunks = 231608221292675